import { render, staticRenderFns } from "./DiscussionSummary.vue?vue&type=template&id=1cfaaba0"
import script from "./DiscussionSummary.vue?vue&type=script&lang=js"
export * from "./DiscussionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports